import { useEffect, useState, type ComponentProps } from 'react';
import Cal, { getCalApi } from '@calcom/embed-react';
import { getTheme, type Theme } from '@/lib/theme';

function useSiteTheme(): Theme {
  const [theme, setThemeState] = useState<Theme>(() => getTheme());
  useEffect(() => {
    const sync = () => setThemeState(getTheme());
    window.addEventListener('themechange', sync);
    return () => window.removeEventListener('themechange', sync);
  }, []);
  return theme;
}

export function Calendar({ onBooked, note }: { onBooked: string; note: string }) {
  const theme = useSiteTheme();
  useEffect(() => {
    (async () => {
      const cal = await getCalApi({ namespace: '30min' });
      cal('ui', {
        theme,
        styles: { branding: { brandColor: '#2563eb' } },
        hideEventTypeDetails: false,
        layout: 'month_view',
      });
      cal('on', {
        action: 'bookingSuccessful',
        callback: () => {
          window.location.href = onBooked;
        },
      });
    })();
  }, [theme, onBooked]);

  return (
    <div>
      <div
        className="cal-embed-container border border-white/10 rounded-md overflow-hidden"
        style={{ minHeight: '650px' }}
      >
        <Cal
          namespace="30min"
          calLink="7sigma/30min"
          style={{ width: '100%', minHeight: '650px', border: 'none' }}
          // cal.com types config values as strings; the embed reads hideBranding as a boolean.
          config={
            { layout: 'month_view', theme, hideBranding: false } as unknown as ComponentProps<
              typeof Cal
            >['config']
          }
        />
      </div>
      <p className="text-white/55 text-sm mt-4">{note}</p>
    </div>
  );
}
